exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".seal[data-v-06d8cf8d] {\n  width: 100px;\n  height: 100px;\n  position: fixed;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  display: block;\n  background-size: 100%;\n  background-position-y: 50%;\n  background-repeat: no-repeat;\n}\n", ""]);

// exports
